import Rellax from "rellax";

export const setupRellax = () => {
    new Rellax('#background-wrapper', {
        speed: 100,
        center: false,
        wrapper: null,
        round: true,
        vertical: true,
        horizontal: false
    });
};
